import 'dayjs/locale/uz'

const uz = {
  calendar: {
    sameDay: '[Бугун соат] LT [да]',
    nextDay: '[Эртага] LT [да]',
    nextWeek: 'dddd [куни соат] LT [да]',
    lastDay: '[Кеча соат] LT [да]',
    lastWeek: '[Утган] dddd [куни соат] LT [да]',
    sameElse: 'L'
  }
}

export default uz
